import './index.css';
import { useEffect } from 'react';
import { AppRouter } from './router';
import { syncManager } from './lib/syncManager';
import { useAuthStore } from './stores/authStore';

syncManager.setUserIdProvider(() => useAuthStore.getState().user?.id);

function App() {
  useEffect(() => {
    const hydrate = () => {
      void syncManager.processQueue();
    };
    if (useAuthStore.persist.hasHydrated()) {
      hydrate();
    }
    return useAuthStore.persist.onFinishHydration(hydrate);
  }, []);

  return <AppRouter />;
}

export default App;
